export const install = {
  title: 'Add First Weeks to your home screen',
  body: 'One tap to open, works without a signal, and your log is kept safely on this phone.',
  // iPhone gets the stronger pitch because Safari really does clear stored
  // data for sites you have not opened in a week.
  bodyIos:
    'One tap to open, and it works without a signal. On iPhone this also keeps Safari from clearing your log if you go a week without opening it.',
  addButton: 'Add to home screen',
  installing: 'Adding…',

  // Three steps: newer versions of Safari put Share inside the options menu
  // rather than straight on the toolbar.
  step1Before: 'Tap the',
  optionsLabel: 'options menu',
  step1After: 'in the address bar',
  step2Before: 'Choose',
  shareLabel: 'Share',
  step3Before: 'Choose',
  addToHomeScreen: 'Add to Home Screen',

  finePrint:
    'Adding it this way installs it straight from your pediatrician, with no app store and no account. Nothing is downloaded through Apple or Google, so no store has a record of it, and your log stays yours on your own phone instead of sitting in a company\'s account somewhere.',
};
